import React from "react";


import { Box, BoxOwner } from "../../../../../../dtos/box";
import { BoxFeatureSetup } from "../../types";

import { AddOwnerDialog } from "./AddOwnerDialog";
import { AddOwnerFlowContextProvider } from "./AddOwnerFlowContext";
import { CreateNewLeaseDialog } from "./CreateNewLeaseDialog";
import { CustomerRegisterDialog } from "./CustomerRegisterDialog";
import { OpenAddOwnerDialogButton } from "./OpenAddOwnerDialogButton";
import { UpdateLeaseDialog } from "./UpdateLeaseDialog";

interface Props {
    box: Box;
    owners: BoxOwner[];
    onBoxOwnerAdded: () => void;
    boxFeatures: BoxFeatureSetup;
}

export function AddOwnerFlow({
    box,
    owners,
    onBoxOwnerAdded,
    boxFeatures,
}: Props) {
    return (
        <AddOwnerFlowContextProvider
            box={box}
            owners={owners}
            boxFeatures={boxFeatures}
            onBoxOwnerAdded={onBoxOwnerAdded}
        >
            <OpenAddOwnerDialogButton />
            <AddOwnerDialog />
            <CustomerRegisterDialog />
            <CreateNewLeaseDialog />
            <UpdateLeaseDialog />
        </AddOwnerFlowContextProvider>
    );
}
